import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from 'src/app/shared/shared.module';
import { RechargeModalComponent } from './recharge-modal.component';

/**
 * Módulo do modal de recarga por valor (CU-86akn0zp6).
 *
 * Existe porque o modal tem DOIS donos: o painel, que é eager, e a tela da
 * carteira, que é lazy. Declará-lo no `WalletModule` obrigaria o painel a
 * carregar o módulo lazy da carteira inteiro só para abrir uma recarga;
 * declará-lo no `SharedModule` o empurraria para os outros quinze módulos que
 * importam o compartilhado e não têm nada com recarga.
 *
 * Um módulo próprio, importado pelos dois, é o menor pedaço que resolve as
 * duas coisas — e mantém o componente onde ele pertence, em `pages/wallet/`.
 */
@NgModule({
  declarations: [RechargeModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModalModule,
    SharedModule,
  ],
  exports: [RechargeModalComponent],
})
export class RechargeModalModule {}
